import Autocomplete from '@mui/material/Autocomplete';
import { useFetch } from '../hooks/useFecth';
import { FormHelperText } from '@mui/material';
import { TextField } from '@mui/material';

export default function SelectAdvertiser({ value, name, onChange, placeholder, label, list }) {
    const { data, error, isFetching } = useFetch(`advertiser`, { params: { status: true, paged: false } });

    const options = data?.map(item => ({ id: item.id, label: item.name })) || [];
    const selected = options.find(item => value === String(item.id)) || null;

    return (
        <>
            <Autocomplete
                fullWidth
                placeholder={placeholder}
                getOptionLabel={e => e?.label || ''}
                getOptionKey={e => e.id}
                isOptionEqualToValue={(option, optionValue) => option?.id === optionValue?.id}
                options={options}
                value={selected}
                name={name}
                loading={isFetching}
                onChange={(_, newValue) => onChange(name, newValue?.id != null ? String(newValue.id) : '')}
                renderInput={params => <TextField {...params} label={placeholder || label} />}
            />
            {!!error?.message && <FormHelperText>{error?.message}</FormHelperText>}
        </>
    );
}
